export default "__VITE_ASSET__0bd3025b__"